// AdminSideBar.jsx

import React from "react";
import {
  FiShoppingBag,
} from "react-icons/fi";
import { GrWorkshop } from "react-icons/gr";
import { RxDashboard } from "react-icons/rx";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineUserGroup } from "react-icons/hi";
// import { MdOutlineLocalOffer } from "react-icons/md";
import { AiOutlineSetting } from "react-icons/ai";
import { CiLogout } from "react-icons/ci";
import axios from "axios"; // If not already imported
import { server } from "../../../server"; // Adjust the path as necessary

const menuItems = [
  {
    id: 1,
    name: "Dashboard",
    icon: <RxDashboard size={24} />,
    path: "/admin/dashboard",
  },
  {
    id: 2,
    name: "All Orders",
    icon: <FiShoppingBag size={24} />,
    path: "/admin-orders",
  },
  {
    id: 3,
    name: "All Sellers",
    icon: <GrWorkshop size={24} />,
    path: "/admin-sellers",
  },
  {
    id: 4,
    name: "All Users",
    icon: <HiOutlineUserGroup size={24} />,
    path: "/admin-users",
  },
  // {
  //   id: 5,
  //   name: "All Offers",
  //   icon: <MdOutlineLocalOffer size={24} />,
  //   path: "/admin-offers",
  // },
  {
    id: 6,
    name: "Settings",
    icon: <AiOutlineSetting size={24} />,
    path: "/profile",
  },
  {
    id: 7,
    name: "All Sales",
    icon: <FiShoppingBag size={24} />,
    path: "/admin-sales",
  },
  {
    id: 8,
    name: "Create Invoice",
    icon: <GrWorkshop size={24} />,
    path: "/admin-create-invoice",
  },
  {
    id: 9,
    name: "All Purchase Invoices",
    icon: <FiShoppingBag size={24} />,
    path: "/admin-seller-invoices",
  },
  {
    id: 10,
    name: "Purchase invoice Entry",
    icon: <GrWorkshop size={24} />,
    path: "/admin-create-seller-invoice",
  },
];

const AdminSideBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const logoutHandler = async () => {
    try {
      await axios.get(`${server}/admin/logout`, { withCredentials: true });
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
      // Optionally, handle error (e.g., show a notification)
    }
  };

  // Function to determine if a menu item is active
  const isActive = (path) => {
    return currentPath === path;
  };

  return (
    <div
      className="
        flex flex-col
        w-16 sm:w-64
        h-screen
        bg-white
        shadow-lg
        overflow-y-auto
        sticky
        top-0
        left-0
        z-10
        transition-width
        duration-300
        ease-in-out
      "
    >
      <div className="flex flex-col flex-grow mt-4">
        {menuItems.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`
                flex items-center px-4 py-3 my-1 rounded-md transition-colors duration-200
                ${
                  active
                    ? "bg-green-100 text-green-800"
                    : "text-gray-600 hover:bg-gray-100 hover:text-green-800"
                }
              `}
              aria-current={active ? "page" : undefined}
            >
              <div className={`flex justify-center w-8`}>
                <div className={`${active ? "text-green-800" : "text-gray-600"}`}>
                  {item.icon}
                </div>
              </div>
              <span className="ml-3 hidden sm:inline text-lg font-medium">
                {item.name}
              </span>
            </Link>
          );
        })}

        {/* Logout Button */}
        <div
          onClick={logoutHandler}
          className="flex items-center px-4 py-3 my-1 rounded-md cursor-pointer text-gray-600 hover:bg-gray-100 hover:text-green-800 transition-colors duration-200"
        >
          <div className="flex justify-center w-8">
            <CiLogout size={24} />
          </div>
          <span className="ml-3 hidden sm:inline text-lg font-medium">Logout</span>
        </div>
      </div>
    </div>
  );
};

export default AdminSideBar;


